import React, { useContext } from 'react';
import { UserContext } from '../context';
import { DropDown } from '../dropdown';
import { Icon } from '../icon';
import {
  TagAddIcon,
  TagCheckIcon,
  TagBlockIcon,
  TagRemoveIcon,
  UserAddIcon,
  UserBlockIcon,
  UserCheckIcon,
  UserRemoveIcon,
  ListAddIcon,
  ListBlockIcon,
  ListCheckIcon,
  ListRemoveIcon,
} from 'icons';

const dropDownTypes = {
  tag: {
    label: 'tag',
    addIcon: TagAddIcon,
    blockIcon: TagBlockIcon,
    checkIcon: TagCheckIcon,
    removeIcon: TagRemoveIcon,
  },
  user: {
    label: 'reaguurder',
    addIcon: UserAddIcon,
    blockIcon: UserBlockIcon,
    checkIcon: UserCheckIcon,
    removeIcon: UserRemoveIcon,
  },
  list: {
    label: 'item',
    addIcon: ListAddIcon,
    blockIcon: ListBlockIcon,
    checkIcon: ListCheckIcon,
    removeIcon: ListRemoveIcon,
  },
};

export const DropDownActions = ({
  type = 'tag',
  added = false,
  addAction = null,
  blocked = false,
  blockAction = null,
  removeAction = null,
  ...restProps
}) => {
  const { user } = useContext(UserContext);
  const { label, addIcon, blockIcon, checkIcon, removeIcon } = dropDownTypes[type];

  const dropDownIcon = () => {
    if (added || blocked) {
      return added ? checkIcon : blockIcon;
    } else {
      return addIcon;
    }
  };

  return (
    <>
      {user && (
        <DropDown
          ClickElement={() => <Icon Type={dropDownIcon()} tw='w-4 h-4 ml-1 mr-4' {...restProps} />}
        >
          {(added || blocked) && (
            <Icon
              Type={removeIcon}
              label={`Verwijder ${label}`}
              fontWeight='regular'
              iconLeft
              noSpacing
              tw='mb-1'
              onClick={removeAction}
            />
          )}
          {!(added || blocked) && (
            <>
              <Icon
                Type={checkIcon}
                label={`Favoriet ${label}`}
                fontWeight='regular'
                iconLeft
                noSpacing
                tw='mb-1'
                onClick={addAction}
              />
              <Icon
                Type={blockIcon}
                label={`Blokkeer ${label}`}
                fontWeight='regular'
                iconLeft
                noSpacing
                onClick={blockAction}
              />
            </>
          )}
        </DropDown>
      )}
    </>
  );
};
